<template>
  <div>
    <v-row>
      <v-col
        v-for="(file, attachmentKey) in attachmentsData"
        :key="attachmentKey"
        cols="12"
        class="attachment-col"
      >
        <attachment-card
          :file="{ ...file, attachmentKey }"
          :show-delete-button="isEditMode && !file.isAttachmentAudited"
          @viewAttachment="viewAttachment"
          @deleteAttachment="showDeleteModal"
          @show-modal="showAttachmentPanel"
        ></attachment-card>

        <div class="attachment-details-sub-panel">
          <attachment-details-panel
            v-if="selectedAttachmentId == file.id"
            :attachment-type-id="file.id"
            @show-attachment-modal="showAttachmentModal"
          ></attachment-details-panel>
        </div>
      </v-col>
    </v-row>
    <naj-confirmation
      :show-modal="deleteModalVisibility"
      color="error"
      :title="local.common.removeConfirmation"
      :message="removeMessage"
      :ok-btn-label="local.common.remove"
      :action-loading="deleteLoading"
      @ok="deleteAttachment"
      @cancel="hideDeleteModal"
    ></naj-confirmation>
  </div>
</template>

<script>
import AttachmentCard from '@/components/shared/attachment-modal/attachment-card';
import AttachmentDetailsPanel from './attachment-details-panel';
import { createNamespacedHelpers } from 'vuex';
import { attachmentType } from '@/helpers/enum';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('LawsuitModule');
export default {
  components: {
    AttachmentCard,
    AttachmentDetailsPanel,
  },
  data() {
    return {
      attachmentType,
      deleteLoading: false,
      deleteModalVisibility: false,
      requiredAttachments: [],
      selectedAttachmentId: -1,
    };
  },
  mounted() {
    this.handleGetRequiredAttachments();
  },
  computed: {
    ...mapState({
      request: state => state.submittedRequestInfo,
      attachments: state => state.attachments,
      auditFields: state => state.lawsuitRequest.auditFields,
      caseData: state => state.lawsuitRequest.case,
    }),
    ...mapGetters(['isEditMode', 'isAttachmentsListAuditedAndShouldBeDisabled']),
    filteredAttachments() {
      const attachments = Object.values(this.attachments.data);

      return this.requiredAttachments.map((a) => {
        const isFound = !!attachments.find(b => b.category === a.id);

        return {
          ...a,
          isFound,
        };
      });
    },
    placeholders() {
      const attachments = this.filteredAttachments.filter(a => !a.isFound);
      const data = {};

      attachments.map((a) => {
        data[a.id] = {
          ...a,
          isPlaceholder: true,
        };
      });

      return data;
    },
    attachmentsData() {
      return {
        ...this.placeholders,
        ...Object.fromEntries(
          Object.entries(this.attachments.data || {})
            .filter(
              // eslint-disable-next-line no-unused-vars
              ([key, value]) => value.isAttachmentVisible ?? true
            )
        ),
      };
    },
    deleteAttachmentModalVisibility() {
      return this.attachments.deleteAttachmentModal.visibility;
    },
    removeMessage() {
      return this.local.common.dynamicRemoveConfirmationMessage(this.local.attachments.attachment);
    },
  },
  methods: {
    ...mapActions(['getAttachmentURL', 'getAttachmentTypesByRequestObjectKey']),
    handleGetRequiredAttachments() {
      if (this.caseData && this.caseData.caseTypeId) {
        this.loading = true;

        this.getAttachmentTypesByRequestObjectKey(this.request.objectKey).then((data) => {
          this.requiredAttachments = data;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    viewAttachment({ file, attachmentKey }) {
      const attachmentType = (this.requiredAttachments.find(a => a.id == file.category) || {});

      const attachment = {
        fileUrl: file.fileUrl,
        name: file.name,
        fileType: file.fileType,
        categoryName: file.categoryName,
        attachmentFile: file,
        attachmentKey,
        description: attachmentType.description,
        acceptanceCriteria: attachmentType.acceptanceCriteria,
        sampleImageDownloadBase64: attachmentType.downloadBase64,
      };
      attachment.fileUrl
        ? this.$emit('attachmentSelected', attachment)
        : this.getAttachmentURL(attachmentKey).then((imageURL) => {
          attachment.fileUrl = imageURL;
          this.$emit('attachmentSelected', attachment);
        });
    },
    deleteAttachment() {
      this.deleteLoading = true;
      this.$store
        .dispatch('LawsuitModule/deleteAttachment', {
          objectKey: this.objectKey,
          attachmentKey: this.attachmentKey,
        })
        .then(() => {
          this.hideDeleteModal();
        })
        .finally(() => (this.deleteLoading = false));
    },
    hideDeleteModal() {
      this.attachmentKey = null;
      this.objectKey = null;
      this.deleteModalVisibility = false;
    },
    showDeleteModal({ attachmentKey, objectKey }) {
      this.attachmentKey = attachmentKey;
      this.objectKey = objectKey;
      this.deleteModalVisibility = true;
    },
    showAttachmentPanel(id) {
      this.$emit('show-modal', id);
      this.selectedAttachmentId = id;
    },
    showAttachmentModal() {
      this.$emit('show-attachment-modal');
    },
  },
  watch: {
    caseData(value) {
      if (value && value.caseTypeId) {
        this.handleGetRequiredAttachments();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-col {
  cursor: pointer;
  &:first-child {
    padding-top: 0px;
  }
  &:last-child {
    padding-bottom: 0px;
  }
}
</style>
